import {
  LayoutDashboard, FolderOpen, Users, MessageSquare, FileText, Shield, Globe, TrendingUp, Clock,
  Briefcase, DollarSign, Wallet, BarChart2, Building2, UserPlus, ArrowRightLeft, CreditCard, PenTool,
  Mail, Search, Zap, AlertTriangle, Calendar, Phone, Brain, DatabaseBackup, Inbox, Landmark,
  Bot, ClipboardCheck, FolderTree, Users2, Megaphone, KeyRound, ShieldCheck,
} from 'lucide-react';

// Architecture: LCS IMMIGRATION > ADMIN DASHBOARD > CRM | DOSSIERS | EQUIPE
const SR = ['admin', 'employee', 'org_admin', 'org_employee'];
const AR = ['admin', 'org_admin'];
const ALL = ['admin', 'employee', 'client', 'org_admin', 'org_employee'];

export const buildNavGroups = (t) => [
  { items: [
    { name: t('dashboard'), href: '/dashboard', icon: LayoutDashboard, roles: ALL, perm: 'dashboard.view' },
    { name: 'Actions requises', href: '/actions-required', icon: AlertTriangle, roles: SR },
    { name: 'Mon Dossier', href: '/mon-dossier', icon: FolderOpen, roles: ['client'] },
    { name: t('messages'), href: '/messages', icon: MessageSquare, roles: ALL, perm: 'messages.view' },
    { name: 'Approbations', href: '/approbations', icon: ShieldCheck, roles: AR },
    { name: 'Calendrier', href: '/calendar', icon: Calendar, roles: SR },
  ]},
  { group: 'CRM', items: [
    { name: 'Prospects', href: '/prospects', icon: UserPlus, roles: SR, perm: 'prospects.view' },
    { name: t('clients'), href: '/clients', icon: Users, roles: SR, perm: 'clients.view' },
    { name: 'Admissibilité IA', href: '/eligibility', icon: Brain, roles: SR },
  ]},
  { group: 'Dossiers', items: [
    { name: 'Tous les dossiers', href: '/files', icon: FolderOpen, roles: SR, perm: 'files.view' },
    { name: 'Groupes', href: '/groupes', icon: Users2, roles: SR, perm: 'files.view' },
    { name: 'Importation massive', href: '/importation-massive', icon: FolderOpen, roles: SR, perm: 'files.view' },
    { name: 'Organisation intelligente', href: '/organisation-intelligente', icon: FolderTree, roles: AR, perm: 'files.view' },
    { name: 'Dossiers désactivés', href: '/dossiers-desactives', icon: FolderOpen, roles: SR, perm: 'files.view' },
    { name: 'Registre destructions', href: '/registre-destructions', icon: FolderOpen, roles: AR, perm: 'files.view' },
    { name: 'Conformité', href: '/conformite', icon: Shield, roles: AR, perm: 'files.view' },
    { name: 'Intégrité des données', href: '/integrite', icon: Shield, roles: AR, perm: 'files.view' },
    { name: 'Gestion des programmes', href: '/gestion-programmes', icon: Globe, roles: AR, perm: 'files.view' },
    { name: 'Vue Kanban', href: '/kanban', icon: LayoutDashboard, roles: SR, perm: 'files.view' },
    { name: 'Workflow', href: '/workflow-tracker', icon: TrendingUp, roles: SR, perm: 'files.view' },
    { name: 'Questionnaires', href: '/questionnaire-builder', icon: FileText, roles: AR, perm: 'settings.templates' },
  ]},
  { group: 'Equipe', items: [
    { name: 'Employes', href: '/employee-management', icon: Users, roles: AR, perm: 'employees.view' },
    { name: 'Pointage', href: '/timesheet', icon: Clock, roles: SR },
    { name: 'Gestion RH', href: '/rh', icon: Briefcase, roles: SR },
  ]},
  { group: 'Documents & Soumission', items: [
    { name: 'Assistant IA', href: '/ai-assistant', icon: Brain, roles: SR },
    { name: 'Modeles', href: '/document-templates', icon: FileText, roles: AR, perm: 'settings.templates' },
    { name: 'Signatures', href: '/signatures', icon: PenTool, roles: SR },
    { name: 'Controle IRCC', href: '/ircc-control', icon: Shield, roles: SR },
    { name: 'Import historique', href: '/import-historique', icon: DatabaseBackup, roles: AR },
    { name: 'Reconstruction email', href: '/reconstruction-email', icon: Inbox, roles: AR },
  ]},
  { group: 'Facturation', items: [
    { name: 'Devis', href: '/quotes', icon: FileText, roles: SR, perm: 'quotes.view' },
    { name: 'Factures', href: '/invoices', icon: FileText, roles: SR, perm: 'invoices.view' },
    { name: 'Paiements', href: '/payments', icon: DollarSign, roles: SR, perm: 'payments.view' },
    { name: 'Tresorerie', href: '/tresorerie', icon: Wallet, roles: AR, perm: 'special.financial_data' },
    { name: 'Rapprochement CC', href: '/rapprochement-cc', icon: Wallet, roles: AR, perm: 'special.financial_data' },
  ]},
  { group: 'Marketing', items: [
    { name: 'Meta Ads', href: '/marketing/meta-ads', icon: Megaphone, roles: SR },
  ]},
  { group: 'Recrutement AI', items: [
    { name: 'Command Center', href: '/recrutement-ai', icon: Zap, roles: SR },
    { name: 'Autopilot', href: '/recrutement-ai/autopilot', icon: Bot, roles: SR },
    { name: 'Suivi EIMT', href: '/recrutement-ai/eimt', icon: ClipboardCheck, roles: SR },
    { name: 'Employeurs', href: '/recrutement-ai/employeurs', icon: Building2, roles: SR },
    { name: 'Postes', href: '/recrutement-ai/postes', icon: Briefcase, roles: SR },
    { name: 'Candidats', href: '/recrutement-ai/candidats', icon: Users, roles: SR },
    { name: 'Immigration & Conformité', href: '/recrutement-ai/immigration', icon: Shield, roles: SR },
    { name: 'Appels IA', href: '/recrutement-ai/appels', icon: Phone, roles: SR },
    { name: 'Découverte Employeurs', href: '/recrutement-ai/decouverte', icon: Search, roles: SR },
    { name: 'Prospection', href: '/recrutement-ai/prospection', icon: Mail, roles: SR },
    { name: 'Banque de candidats', href: '/recrutement-ai/banque', icon: Landmark, roles: SR },
    { name: 'Portail Employeur', href: '/portail-employeur', icon: Building2, roles: ['employer'] },
    { name: 'Portail Candidat', href: '/portail-candidat', icon: Users, roles: ['candidate'] },
  ]},
  { group: 'Communication', items: [
    { name: 'Centre Appels', href: '/communications', icon: Phone, roles: SR },
    { name: 'WhatsApp', href: '/whatsapp', icon: MessageSquare, roles: SR },
    { name: 'Emails', href: '/email-settings', icon: Mail, roles: AR, perm: 'settings.notifications' },
    { name: 'Recrutement', href: '/recruitment-admin', icon: Users, roles: AR },
  ]},
  { group: 'Administration', items: [
    { name: 'Automatisations', href: '/rules-engine', icon: Zap, roles: AR, perm: 'settings.edit' },
    { name: 'Roles', href: '/role-management', icon: Shield, roles: AR, perm: 'roles.view' },
    { name: 'Rapports', href: '/reporting', icon: BarChart2, roles: AR, perm: 'reports.view' },
    { name: 'Audit', href: '/audit-log', icon: Shield, roles: AR, perm: 'special.audit_log' },
    { name: 'Gestion Paie', href: '/gestion-paie', icon: DollarSign, roles: AR, perm: 'special.financial_data' },
    { name: 'Intégrations & clés', href: '/integrations', icon: KeyRound, roles: ['admin'] },
  ]},
  { group: 'Mon organisation', items: [
    { name: 'Profil', href: '/org-profile', icon: Building2, roles: ['org_admin'] },
    { name: 'Dossiers recus', href: '/transfers', icon: ArrowRightLeft, roles: ['org_admin'] },
  ]},
  { group: 'Plateforme', superAdminOnly: true, items: [
    { name: 'Organisations', href: '/organizations', icon: Building2, roles: ['admin'], superAdminOnly: true },
    { name: 'Transferts', href: '/transfers', icon: ArrowRightLeft, roles: ['admin'], superAdminOnly: true },
    { name: 'Abonnements', href: '/subscriptions', icon: CreditCard, roles: ['admin'], superAdminOnly: true },
  ]},
];

const isVisible = (item, user, can) => {
  if (!item.roles?.includes(user?.role)) return false;
  if (item.superAdminOnly && !user?.is_super_admin) return false;
  if (item.perm && !can(item.perm)) return false;
  return true;
};

// Aplatit les groupes visibles : [{ label?, items }] -> { items, groupLabels: [{ label, idx }] }
export const filterNavigation = (navGroups, user, can) => {
  const items = [];
  const groupLabels = [];
  navGroups.forEach(grp => {
    if (grp.superAdminOnly && !user?.is_super_admin) return;
    const vis = grp.items.filter(item => isVisible(item, user, can));
    if (vis.length === 0) return;
    if (grp.group) groupLabels.push({ label: grp.group, idx: items.length });
    items.push(...vis);
  });
  return { items, groupLabels };
};
